"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
const doctors = [{
  name: "Shaik Azrin bin Shaik Daud",
  position: "Founding Partner",
  bio: "A seasoned legal practitioner with 29 years of experience specializing in Employment Law and Civil Litigation.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/shaik_azrin_portrait.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/shaik_azrin_portrait.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/shaik_azrin_portrait.png-wvc-sizes",
    alt: "Portrait of Shaik Azrin bin Shaik Daud"
  }
}, {
  name: "Shaik Azrul bin Shaik Daud",
  position: "Senior Partner",
  bio: "Expert in Industrial Relations and Corporate Advisory, providing strategic legal solutions for complex business challenges.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/shaik_azrul_portrait.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/shaik_azrul_portrait.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/shaik_azrul_portrait.png-wvc-sizes",
    alt: "Portrait of Shaik Azrul bin Shaik Daud"
  }
}, {
  name: "Legal Support Team",
  position: "Advocates & Solicitors",
  bio: "Our dedicated team of legal professionals ensures every case is handled with meticulous care and strategic precision.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/legal_team_portrait.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/legal_team_portrait.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/legal_team_portrait.png-wvc-sizes",
    alt: "Portrait of Shaik Azrin & Co Legal Team"
  }
}];
export default function OurExpertClinicians() {
  return <section data-section-id="243666" id="theseniorpartner" className="bg-background text-foreground py-[120px] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          <div className="lg:col-span-5 flex flex-col items-start space-y-6">
            <span className="tracking-widest text-white uppercase !font-default !font-bold !text-5xl">SENIOR PARTNER</span>
            <h2 className="font-serif text-primary leading-tight tracking-tight !font-normal !italic !text-3xl">Shaik Azrul bin Shaik Daud</h2>
            <p className="font-sans text-base text-muted-foreground leading-relaxed !text-justify"><br />Shaik Azrul bin Shaik Daud graduated from the International Islamic University (IIU) and started off his legal career as a legal assistant at&nbsp; Messrs Yusuf Khan &amp; Pathmanathan. Shaik Azrul's capabilities landed him the opportunity to act as Legal Executive at the then Arab-Malaysian Bank Berhad, now known as AmBank (M) Berhad. He served at the Bank for over 4 years. He had a brief stint as Legal Executive at Malaysia Trustees Berhad, thereafter resuming his law practice in January 2004. After a year, Shaik Azrul joined his brother at Shaik Azrin &amp; Co and has acted as Senior Partner since.<br /><br />Shaik Azrul's areas of expertise include Litigation, Corporate and Conveyancing for companies and individuals. He has wide knowledge on conveyancing transactions. Shaik Azrul is well versed with Land Office procedures in obtaining consent for transfers, foreign acquisition of properties, dealings with property developers and real estate agents.</p>
            
          </div>

          
          <div className="lg:col-span-7 relative">
            <div className="group relative overflow-hidden aspect-[3/4] bg-primary shadow-2xl">
              <img src="https://shaikazrinco.com/wp-content/uploads/2026/05/855a1534-8c6d-4594-94d2-0af2b1db0636.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/shaik_azrul_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/shaik_azrul_portrait.png-wvc-sizes" alt="Portrait of Shaik Azrul bin Shaik Daud" className="w-full h-full object-cover object-center transition-all duration-700 ease-in-out group-hover:scale-105" loading="lazy" />
            </div>
            <div className="mt-4 text-center">
              <h3 className="font-serif text-2xl font-semibold text-white mb-1">Shaik Azrul bin Shaik Daud</h3>
              <p className="font-sans text-sm text-secondary font-medium tracking-wide uppercase">Senior Partner</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}